import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  :root {
    --font-display: 'Nunito', 'Inter', sans-serif;
    --primary-color: #2DD4BF;
    --primary-rgb: 45, 212, 191;
    --primary-dark: #14B8A6;
    --primary-light: #5EEAD4;
    --primary-muted: rgba(var(--primary-rgb), 0.14);
    --secondary-color: #94A3B8;
    --secondary-dark: #64748B;
    --background-color: #0C0F14;
    --surface-color: #141820;
    --surface-raised: #1A1F2B;
    --error-color: #F87171;
    --text-primary: #F8FAFC;
    --text-secondary: rgba(248, 250, 252, 0.72);
    --text-disabled: rgba(248, 250, 252, 0.38);
    --border-color: rgba(255, 255, 255, 0.08);
    --border-radius: 12px;
    --box-shadow: 0 8px 32px rgba(0, 0, 0, 0.24);
    --accent-solid: var(--type-accent, var(--primary-color));
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    font-family: 'Inter', 'Roboto', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: var(--background-color);
    color: var(--text-primary);
    font-size: 16px;
    min-height: 100vh;
    overflow-x: hidden;
  }

  a {
    text-decoration: none;
    color: var(--primary-light);
  }

  button {
    font-family: 'Inter', 'Roboto', 'Helvetica Neue', sans-serif;
    cursor: pointer;
    border: none;
    outline: none;
    background: none;
  }

  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 1rem;
    line-height: 1.2;
  }

  p {
    margin-bottom: 1rem;
    line-height: 1.6;
  }

  :focus-visible {
    outline: 2px solid var(--accent-solid);
    outline-offset: 3px;
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }

  .dna-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-color: var(--background-color);
    background-image: radial-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px);
    background-size: 24px 24px;
    opacity: 1;
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .fade-in {
    animation: fadeIn 0.5s ease-in-out;
  }
`;

export default GlobalStyle;
